import { DataLinkConfig } from '../../../../../../../components/common-configs/DataLinkConfig'

export function CreateDataLink() {
  return <DataLinkConfig />
}
